import { useMemo } from 'react'
import * as React from 'react'

import PropertyMap from 'components/Common/PropertyMap'
import type { PropertyMapOptions } from 'components/Common/PropertyMap/types'
import Group from 'components/utils/Group'
import { nonNullable } from 'lib/array/arrayUtils'

interface Props {
  primaryMapMarker?: App.MapMarker
  pickupMapMarker?: App.MapMarker
  locationMapMarkerList?: Array<App.MapMarker>
  style: React.CSSProperties
}

const MAP_OPTIONS: PropertyMapOptions = {
  fullscreenControl: false,
}

function ExperienceMap(props: Props) {
  const {
    primaryMapMarker,
    pickupMapMarker,
    locationMapMarkerList,
    style,
  } = props

  const markers = useMemo(() => {
    return nonNullable([
      primaryMapMarker && {
        ...primaryMapMarker,
        openGoogleMapsOnSelect: false,
      },
      pickupMapMarker && {
        ...pickupMapMarker,
        openGoogleMapsOnSelect: false,
      },
      ...(locationMapMarkerList ?? []).map((marker) => ({
        ...marker,
        openGoogleMapsOnSelect: false,
      })),
    ])
  }, [locationMapMarkerList, pickupMapMarker, primaryMapMarker])

  return <Group direction="vertical">
    <PropertyMap
      height={style.height}
      wrapperStyle={style}
      markers={markers}
      multipleMarkers
      mapOptions={MAP_OPTIONS}
      showActiveMarkerState={false}
    />
  </Group>
}

export default ExperienceMap
